/* fs-vip-sale.js (Oct 27 2026, Deputy build, STAGED + DORMANT)
   The subscriber (VIP) sale page.
   - Works out the phase from the clock in Pacific time: before / open / ended.
   - Code box: the page only holds a SHA-256 fingerprint of the code (never the code). The typed code is fingerprinted in
     the browser and compared. If it matches: remember it and unlock the page IN PLACE. The code is only a key for the four holiday gifts
     (FIX ROUND 5, Nov 2): it is never sent to /discount or to checkout. Free shipping is an automatic discount for everyone.
   - Unlocked: fills in the reveal area from the hidden <template> (so the subscriber-only items are not in the page until the code is right).
   - Checkbox "I'm sending gifts to up to 3 addresses in Canada": saved as a cart attribute through /cart/update.js.
   Preview only (theme role is not "main"): add ?fsvip=before | open | unlocked | ended | reset to the address to look at each state early (reset forgets a saved unlock).
   It does nothing on the live theme. This is a soft gate: it hides the VIP items on this page; it does not lock product web addresses. */
(function () {
  var root = document.querySelector('[data-fsh-vip]');
  if (!root) return;

  var KEY = 'fsh_vip_unlocked_v1';
  var ATTR_NAME = root.getAttribute('data-attr-name') || "Sending gifts to up to 3 addresses";
  var hash = (root.getAttribute('data-code-hash') || '').toLowerCase();
  var opens = parseInt(root.getAttribute('data-opens'), 10) * 1000;   // epoch ms
  var ends = parseInt(root.getAttribute('data-ends'), 10) * 1000;
  var isMain = (window.Shopify && Shopify.theme && Shopify.theme.role === 'main');
  var qs = new URLSearchParams(location.search);
  var forced = (!isMain && qs.get('fsvip')) || '';
  if (!isMain && qs.get('nosave') === '1') { root.classList.add('fsh-vip--nosave'); }   // FIX ROUND 1, staged for Nat: hides the two (you save ...) lines in a preview
  if (forced === 'reset') { try { localStorage.removeItem(KEY); } catch (e) {} forced = 'open'; }   // preview only: forget a saved unlock and show the code box

  var panels = {};
  root.querySelectorAll('[data-panel]').forEach(function (p) { panels[p.getAttribute('data-panel')] = p; });
  var reveal = root.querySelector('[data-reveal]');
  var tpl = root.querySelector('template[data-reveal-template]');

  function phase() {
    if (forced === 'before' || forced === 'ended') return forced;
    if (forced === 'open' || forced === 'unlocked') return 'open';
    var now = Date.now();
    if (isFinite(opens) && now < opens) return 'before';
    if (isFinite(ends) && now >= ends) return 'ended';
    return 'open';
  }
  function isUnlocked() {
    if (forced === 'unlocked') return true;
    try { return localStorage.getItem(KEY) === hash && hash.length > 0; } catch (e) { return false; }
  }
  function show(name) {
    Object.keys(panels).forEach(function (k) { panels[k].hidden = (k !== name); });
    root.setAttribute('data-state', name);
  }
  function fillReveal() {
    if (reveal && tpl && !reveal.getAttribute('data-filled')) {
      reveal.appendChild(tpl.content.cloneNode(true));
      reveal.setAttribute('data-filled', '1');
      bindMulti();
    }
  }
  function render() {
    var ph = phase();
    if (ph === 'before') return show('before');
    if (ph === 'ended') return show('ended');
    if (isUnlocked()) { show('unlocked'); fillReveal(); return; }
    show('locked');
  }

  function sha256hex(str) {
    if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.reject(new Error('no-crypto'));
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }

  // B3: after a right code, keyboard focus moves to the new "Welcome" heading (the code box is gone by then)
  function focusHeading() {
    var h = root.querySelector('[data-panel="unlocked"] h1');
    if (h) { h.setAttribute('tabindex', '-1'); try { h.focus(); } catch (e) {} }
  }

  var form = root.querySelector('[data-code-form]');
  if (form) {
    var input = form.querySelector('input[name="vip_code"]');
    var msg = form.querySelector('[data-code-msg]');
    var submit = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var typed = (input.value || '').trim();
      msg.textContent = '';
      if (!typed) { msg.textContent = 'Please type your VIP code.'; input.focus(); return; }
      submit.disabled = true;
      sha256hex(typed.toLowerCase()).then(function (h) {
        if (h !== hash) {
          submit.disabled = false;
          msg.textContent = "That code didn't match. Check your VIP email and try again.";
          input.focus();
          return;
        }
        try { localStorage.setItem(KEY, hash); } catch (err) {}
        // A right code unlocks the page in place, on the live site and in a preview. Nothing is sent anywhere.
        submit.disabled = false;
        render();
        focusHeading();
      }).catch(function () {
        submit.disabled = false;
        msg.textContent = 'This browser could not check the code. Please try another browser, or email us at customerservice@freshsudssoapery.ca.';
      });
    });
  }

  // ---- multi-home checkbox -> cart attribute ----
  function bindMulti() {
    var cb = root.querySelector('[data-multi-home]');
    if (!cb || cb.getAttribute('data-bound')) return;
    cb.setAttribute('data-bound', '1');
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cb.checked = !!(c && c.attributes && c.attributes[ATTR_NAME]);
    }).catch(function () {});
    var status = root.querySelector('[data-multi-status]');
    cb.addEventListener('change', function () {
      var body = { attributes: {} };
      body.attributes[ATTR_NAME] = cb.checked ? 'Yes' : '';
      cb.disabled = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); })
        .then(function () { if (status) status.textContent = cb.checked ? 'Saved on your order.' : 'Removed from your order.'; })
        .catch(function () { cb.checked = !cb.checked; if (status) status.textContent = 'Could not save that. Please try again.'; })
        .then(function () { cb.disabled = false; });
    });
  }

  render();
  try { if (sessionStorage.getItem('fsh_vip_focus') === '1' && root.getAttribute('data-state') === 'unlocked') { sessionStorage.removeItem('fsh_vip_focus'); focusHeading(); } } catch (e) {}
  // re-check once a minute so a page left open flips at the right moment (clock only, no network)
  setInterval(render, 60000);
})();
